import * as yup from 'yup';
import pl from './pl';

const language = localStorage.getItem('language') ?? 'en';
if (language === 'pl') {
    yup.setLocale(pl);
}

export default yup;
